import React from 'react';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import { Box, Typography } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import ASE from '../../images/ASE.png';
import ASE1 from '../../images/ASE1.png';
import ASE2 from '../../images/ASE2.png';
import ASE3 from '../../images/ASE3.png';
import ASE4 from '../../images/ASE4.png';

const images = [
    {
        original: ASE,
        thumbnail: ASE,
        description: 'NetApp ASE Certification'
    },
    {
        original: ASE1,
        thumbnail: ASE1,
        description: 'NetApp ASE 1 Certification'
    },
    {
       original: ASE2,
       thumbnail: ASE2,
       description: 'NetApp ASE 2 Certification'
    },
    {
      original: ASE3,
      thumbnail: ASE3,
      description: 'NetApp ASE 3 Certification'
    },
   {
     original: ASE4,
     thumbnail: ASE4,
     description: 'NetApp ASE 4 Certification'
    },
   {
     original: ASE,
     thumbnail: ASE,
     description: 'NetApp ASE Certification'
    },
    // Add more images as needed
];

const MyGallery = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (

        <Box sx={{ width: isMobile ? '90%' : '90%', margin: 'auto' }}>
          <Typography variant="h4" component="div" gutterBottom sx={{
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: isMobile ? '30px' : '40px',
            color: 'black',
            margin: isMobile ? '5%' :'2%'
           
          }}>
             My <span style={{color:'#f9004d'}}>Certifications</span>
          </Typography>
            <ImageGallery items={images} showThumbnails={isMobile ? true : true} />
        </Box>
    );
};

export default MyGallery;
